import Producer from './Producer';

export default Producer;
